import { EngineContext, getLayout as getGameLayout } from '../../../layouts/GameLayout'
import { fetchAsset } from '../../../hooks/nft'
import useExhibition from '../../../hooks/useExhibition'
import AssetPanel from '../../../components/asset/AssetPanel'
import Header from '../../../components/Header'
import { connect } from 'react-redux'
import { useContext, useEffect, useRef, useState } from 'react'
import { openPopout } from '../../../redux/site'
import Button from '../../../components/Button'
import Link from 'next/link'
import Image from 'next/image'
import Onboarding from '../../../components/onboarding/Onboarding'
import Authenticate from '../../../components/auth/Authenticate'
import { useRouter } from 'next/router'
import Loader from '../../../components/Loader'
import useSWR from 'swr'
import ASSETS from '../../../data/the-making-of-heroes'
import Head from 'next/head'


const ExhibitionMetadata = _ => {
  return <>
    <title>Heroes</title>
    <meta name="description" content='The Making of Heroes Behind the Scenes Exhibition'/>

    {/* Twitter */}
    <meta name="twitter:card" content="summary" key="twcard" />
    <meta name="twitter:creator" content='@cryptdotart' key="twhandle" />

    {/* Open Graph */}
    <meta property="og:url" content={process.env.NEXT_PUBLIC_SITE_URL + 'exhibitions/heroes'} key="ogurl" />
    <meta property="og:image" content='https://www.crypt.art/images/exhibitions/still_themakingofheroes.png' key="ogimage" />
    <meta property="og:site_name" content='The Crypt' key="ogsitename" />
    <meta property="og:title" content='Heroes' key="ogtitle" />
    <meta property="og:description" content='An exhibition by Signalnoise that pays homage to the wonderful pieces of technology of yesteryear' key="ogdesc" />
  </>
}

const getAsset = assetId => fetchAsset(ASSETS[assetId])

const Heroes = props => {
  const { site, asset } = props
  const [isExploring, setRequestExplore, progress] = useExhibition()
  const { query } = useRouter()
  const isAssetPath = !!(query.asset && query.asset.length > 0)

  return (
    <>    
      <ExhibitionMetadata />
      {!site.popoutState && !isExploring && !asset && (
        <div className='flex-grow p-6 md:p-4 select-none text-left pointer-events-auto'>
          <div className='space-y-4'>
            <h1 className='text-white font-display text-5xl md:text-6xl lg:text-8xl xl:text-9xl'>The Making Of Heroes</h1>
            <p className='hidden md:block max-w-prose text-white'>Curated in memory of Maurice 'Mo Gillett'. This exhibition presents personal pictures of some of our favourite heroes and iconic moments in movie history.</p>
            {/* . Maurice 'Mo Gillett' was born on 22nd September 1918 and dedicated his career to film making as one of the most respected gaffers (chief electrician) in the business, where he worked on some of the most iconic films of all time including Oliver, Half a Sixpence, Out of Africa, Superman, Batman to name a few. This exhibition presents personal pictures of some of our favourite heroes and iconic moments in movie history. */}
          </div>
          <div className='flex space-x-8 pt-8 items-center w-full pointer-events-auto'>
            <Button className='' onClick={setRequestExplore}>
              View the collection
            </Button>
          </div>
        </div>
      )}
      {asset && (
        <AssetPanel asset={asset} />
      )}
    </>
  )
}



export const getStaticProps = async ({ params }) => {
  const props = { sceneName: 'the-making-of-heroes', heroImage:'/images/exhibitions/still_themakingofheroes.png' }
  if (!params.asset) return { props }
  
  const asset = await getAsset(params.asset[0])

  return {
    props: { 
      ...props, 
      asset,
      revalidate: 60
   }
  }
}

export const getStaticPaths = async _ => {

  const assetNames = Object.keys(ASSETS)

  const assetPaths = assetNames.map(assetName => ({ params: { asset: [assetName] } }))

  const paths = [{ params: { asset: [''] } }, ...assetPaths]
  return {
    paths,
    fallback: false
  }
}

const mapStateToProps = ({ site }, ownProps) => ({ ...ownProps, site })
const ConnectedHeroes = connect(mapStateToProps, null )(Heroes)

ConnectedHeroes.getLayout = getGameLayout
export default ConnectedHeroes
